export const locale = {
  lang: 'sp',
  data: {
    SAMPLE: {
      AWESOME: 'Crear Impresionante 🙌'
    }
  }
}
